import React , { Component } from 'react';
import styled, { css, keyframes } from 'react-emotion';
import { screenWidths } from './../../utils/constants';

const Info = styled.div`
    width: 100%;
`;

export const Title = styled.h2`
  font-family: ZeitungMicroPro-Light;
  font-weight: normal;
  margin-bottom: 55px;
  font-size: 50px;
  color:  #424149;
  @media screen and (min-width: ${screenWidths.lg}px) {
    text-align: left;
  }

  @media screen and (min-width: 320px) {

    font-size:45px !important;
  }
`;

const ColaboradoresContainer = styled.div`
width: 100%;
justify-content: center;

flex-wrap: wrap;
overflow-x: hidden;
display: grid;
grid-column-gap: 40px;
@media screen and (min-width: ${screenWidths.lg}px) {
  grid-template-columns: repeat(4, .5fr);
}
`;
const ColaboradoresContainerAlt = styled.div`
width: 100%;
justify-content: center;

flex-wrap: wrap;
overflow-x: hidden;
display: block;
grid-column-gap: 40px;
@media screen and (min-width: ${screenWidths.lg}px) {

}
`;

const MemberContainer = styled.div`
  text-align: center;

  width: 100%;

  .imgColaborador{
    width:  312.85px;
    height: 312.85px;
    min-width: 312.85px;
    object-fit: cover;
  }

  p {
    margin: 0px 0px 20px 0px;
    font-family: ZeitungMicroPro-Light;
    span {
      font-family: ZeitungMicroPro-Bold;
    }
  }

  @media screen and (min-width: ${screenWidths.lg}px) {

    .imgColaborador{
        width: 150px;
        height: 150px;
        min-width: 150px;
      }
  }

`;
const MemberContainerAlt = styled.div`
  text-align: center;
  margin:2% !important;
  width: 21% !important;
  margin-left: 25.5% !important;

  @media screen and (max-width: 574px) {

    width:100% !important;
    margin:0 !important;
  }

  @media screen and (min-width: 1800px) {

      margin-left: -22% !important;
  }


  float: left;
  .imgColaborador{
    width:  312.85px;
    height: 312.85px;
    min-width: 312.85px;
    object-fit: cover;
  }

  p {
    margin: 0px 0px 20px 0px;
    font-family: ZeitungMicroPro-Light;
    span {
      font-family: ZeitungMicroPro-Bold;
    }
  }

  @media screen and (min-width: ${screenWidths.lg}px) {

    .imgColaborador{
        width: 150px;
        height: 150px;
        min-width: 150px;
      }
  }

`;
const MemberContainerAltLeft = styled.div`
  text-align: center;
  margin:2% !important;
  width: 21% !important;
  float: left;

  @media screen and (max-width: 575px) {

    width:100% !important;
    margin:0 !important;
    margin-left:0 !important;
  }

  float: left;
  .imgColaborador{
    width:  312.85px;
    height: 312.85px;
    min-width: 312.85px;
    object-fit: cover;
  }

  p {
    margin: 0px 0px 20px 0px;
    font-family: ZeitungMicroPro-Light;
    span {
      font-family: ZeitungMicroPro-Bold;
    }
  }

  @media screen and (min-width: ${screenWidths.lg}px) {

    .imgColaborador{
        width: 150px;
        height: 150px;
        min-width: 150px;
      }
  }

`;

const ColaboratorMember = ({colaboradorJob,colaboradorName,fotoColaborador}) => {
return (
  <MemberContainer >
    <img className={"imgColaborador"} src={fotoColaborador.file.url} />
    <p>{colaboradorName}<br/><span>{colaboradorJob}</span></p>
  </MemberContainer>
)
};
const ColaboratorMemberRight = ({colaboradorJob,colaboradorName,fotoColaborador}) => {
return (
  <MemberContainer dir={"right"} >
    <img className={"imgColaborador"} src={fotoColaborador.file.url} />
    <p>{colaboradorName}<br/><span>{colaboradorJob}</span></p>
  </MemberContainer>
)
};
const ColaboratorMemberLeft = ({colaboradorJob,colaboradorName,fotoColaborador}) => {
return (
  <MemberContainer dir={"left"}>
    <img className={"imgColaborador"} src={fotoColaborador.file.url} />
    <p>{colaboradorName}<br/><span>{colaboradorJob}</span></p>
  </MemberContainer>
)
};
const ColaboratorMemberAlt = ({colaboradorJob,colaboradorName,fotoColaborador}) => {
return (
  <MemberContainerAlt>
    <img className={"imgColaborador"} src={fotoColaborador.file.url} />
    <p>{colaboradorName}<br/><span>{colaboradorJob}</span></p>
  </MemberContainerAlt>
)
};
const ColaboratorMemberAltLeft = ({colaboradorJob,colaboradorName,fotoColaborador}) => {
  return (
    <MemberContainerAltLeft>
      <img className={"imgColaborador"} src={fotoColaborador.file.url} />
      <p>{colaboradorName}<br/><span>{colaboradorJob}</span></p>
    </MemberContainerAltLeft>
  )
};

export default class Colaboradores extends Component {
    render() {
        return (
                <Info>
                     <Title>{this.props.title}</Title>

                    {(this.props.colaboradores && (this.props.colaboradores.length%4) == 0) &&
                      <ColaboradoresContainer>
                          {this.props.colaboradores &&
                              this.props.colaboradores.map((c,idx) =>(
                                  <ColaboratorMember {...c}/>
                              ))
                          }
                      </ColaboradoresContainer>
                    }

                    {(this.props.colaboradores && (this.props.colaboradores.length%4) !== 0) &&
                    <ColaboradoresContainerAlt>
                        {this.props.colaboradores &&
                            this.props.colaboradores.map((c,idx) =>(

                              idx != 4 ?
                                <ColaboratorMemberAltLeft {...c}/>
                              :
                              idx != 0 ?
                                <ColaboratorMemberAlt {...c}/>
                              :
                                console.log(idx)
                            ))
                        }
                    </ColaboradoresContainerAlt>
                    }
                </Info>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/About/Colaboradores.js